export const DEFAULT_CURRENCY_BASE_QUERY_KEY = 'default-currency';

export const defaultCurrencyApiQueryKeys = {
  all: () => [DEFAULT_CURRENCY_BASE_QUERY_KEY] as const,
};
